import Base64 from "@/utils/base64";

const selectWeaImg = wea => {
    if (!wea) return;
    let data = [
        {
            "label": "https://z3.ax1x.com/2021/09/08/h7rKGn.png",
            "value": "xue"
        },
        {
            "label": "https://z3.ax1x.com/2021/09/08/h7rXzq.png",
            "value": "qing"
        },
        {
            "label": "https://z3.ax1x.com/2021/09/08/h7rxyV.png",
            "value": "yin"
        },
        {
            "label": "https://z3.ax1x.com/2021/09/08/h7rOWn.png",
            "value": "yu"
        },
        {
            "label": "https://z3.ax1x.com/2021/09/08/h7rvQ0.png",
            "value": "yun"
        },
        {
            "label": "https://z3.ax1x.com/2021/09/08/h7rLJs.png",
            "value": "bingbao"
        },
        {
            "label": "https://z3.ax1x.com/2021/09/08/h7rzLT.png",
            "value": "wu"
        },
        {
            "label": "https://z3.ax1x.com/2021/09/08/h7speU.png",
            "value": "shachen"
        },
        {
            "label": "https://z3.ax1x.com/2021/09/08/h7s9wF.png",
            "value": "lei"
        }
    ]
    return data.find(item => item.value === wea).label
}


const parseTime = (time, pattern) => {
    if (!time && !pattern) {
        return null;
    }
    const format = pattern || "{y}-{m}-{d}";
    let date;
    if (typeof time === "object") {
        date = time;
    } else {
        if (typeof time === "string" && /^[0-9]+$/.test(time)) {
            time = parseInt(time);
        } else if (typeof time === "string") {
            time = time.replace(new RegExp(/-/gm), "/");
        }
        if (typeof time === "number" && time.toString().length === 10) {
            time = time * 1000;
        }
        date = new Date(time);
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    };
    return format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key];
        // Note: getDay() returns 0 on Sunday
        if (key === "a") {
            return ["日", "一", "二", "三", "四", "五", "六"][value];
        }
        if (result.length > 0 && value < 10) {
            value = "0" + value;
        }
        return value || 0;
    });
}

const dateFormat = (date, fmt) => {
    let ret;
    date = new Date(date)
    const opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        }
    }
    return fmt;
}
const jointSvg = (day, code) => {
    if (!day || !code) {
        return require(`@/assets/weather/day/99.svg`)
    }
    return require(`@/assets/weather/${day}/${code}.svg`)
}

const formatMoney = (n) => {
    if (!n) return
    let num = n + ''
    let decimals = ''
    // 判断是否有小数
    num.indexOf('.') > -1 ? decimals = num.split('.')[1] : decimals
    let len = num.length
    if (len <= 3) {
        return num
    } else {
        let temp = ''
        let remainder = len % 3
        decimals ? temp = '.' + decimals : temp
        if (remainder > 0) { // 不是3的整数倍
            return num.slice(0, remainder) + ',' + num.slice(remainder, len).match(/\d{3}/g).join(',') + temp
        } else { // 是3的整数倍
            return num.slice(0, len).match(/\d{3}/g).join(',') + temp
        }
    }
}


const recursion = (list) => {
    list.forEach(item => {
        item.component = () => import(`@/view${item.path}`)
        if (item.children) {
            item.redirect = `${item.path}/index`
            item.component = () => import('@/layout')
            recursion(item.children)
        }
    })
}

const splitUrl = (url) => {
    let base64 = new Base64()

    let split = url.split("$$$");

    let info = []

    for (let i = 0; i < split.length; i++) {

        let s = split[i].split("#")

        let list = []

        for (let j = 0; j < s.length; j++) {
            let item = s[j].split("$");

            let suffix = item[1]
            if (suffix.indexOf(".m3u8") === -1){
                continue
            }
            // if (suffix.indexOf("FQ:") !== -1) {
            //     suffix = "https://jx.fqzy.cc/jx.php?url=" + suffix;
            // }
            let param = {
                name: item [0],
                url: suffix,
            }
            param["eid"] = base64.encode(JSON.stringify(param))
            // _item["eid"] =
            list.push(param)
        }

        if (list.length !== 0){
            info.push({
                name: "线路" + (info.length + 1),
                list: list,
                index: info.length
            })
        }


    }

    return info
}

export {selectWeaImg, parseTime, dateFormat, jointSvg, formatMoney, recursion,splitUrl};
